// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles_iconWrapper__3sEf3"};